import {Controller} from "@hotwired/stimulus";
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        paymentAmount: Number,
        paymentLitigantName: String,
    };

    directPaymentLawyerNotOnboareded(event) {
        $('#direct-payment-cashing-modal').modal('show');
        $('#direct-payment-cashing-modal')
            .find('.direct-payment-text')
            .html(translations
                ["feedback_cashing.kyc_needed_step.You have successfully received a payment of %amount%€ from %litigant_name%. <br> The transfer will be made automatically to your bank account as soon as your payment service is activated with the required documents."]
                .replace('%amount%', this.paymentAmountValue)
                .replace('%litigant_name%', this.paymentLitigantNameValue)
            );
    }
}
